interface LogoProps {
  className?: string;
  size?: number;
}

// LogoMark — identical artwork to the client app and the favicon: champagne-gold
// prediction arcs + S letterform on the brand near-black canvas. Keeps admin and
// client visually unified.
export function LogoMark({ className, size = 32 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="64" rx="14" fill="#06080F" />
      <rect x="1" y="1" width="62" height="62" rx="13" stroke="#D9A441" strokeWidth="1" strokeOpacity="0.2" fill="none" />
      <path d="M 40 8 A 19 19 0 0 1 56 24" stroke="#D9A441" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.3" />
      <path d="M 40 11 A 16 16 0 0 1 53 27" stroke="#D9A441" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.8" />
      <path d="M 38 20 C 36 19 24 18 22 26 C 20 33 31 34 34 36 C 37 38 38 42 34 44 C 30 46 18 45 18 45" stroke="#D9A441" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="49" cy="12" r="4" fill="#D9A441" />
    </svg>
  );
}

export default LogoMark;
